<template>
  <Slideover :visible="visible">
    <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
      <div class="flex items-start justify-between space-x-3">
        <h2 class="text-lg leading-7 font-medium">
          {{ title }}
        </h2>
        <div class="h-7 flex items-center">
          <button
            type="button"
            aria-label="Close panel"
            @click="$emit('toggle-slideover')"
            class="text-green-300 hover:text-white transition ease-in-out duration-150"
          >
            <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
          </button>
        </div>
      </div>
    </header>

    <!-- Main -->
    <div class="p-4 space-y-2">
      <OrderEditProductESD
        v-for="(product, index) in this.editable"
        :key="index"
        :product="product"
        @esd-updated="updateESD($event)"
      />
    </div>

    <div v-if="error" class="px-4 text-right text-red-500">
      Something went wrong!
    </div>

    <!-- Footer -->
    <div class="flex-shrink-0 px-4 py-4 space-x-4 flex justify-end">
      <span class="inline-flex rounded-md shadow-sm">
        <button
          type="button"
          @click="$emit('toggle-slideover')"
          class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
        >
          Cancel
        </button>
      </span>
      <span class="inline-flex rounded-md shadow-sm">
        <Button
          @click-handler="update"
          :disabled="! canUpdate"
          class="flex items-center space-x-2"
        >
          <span>Update</span>
          <LoadingSpinner v-if="processing" class="text-white" />
        </Button>
      </span>
    </div>
  </Slideover>
</template>
<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import OrderEditProductESD from "./OrderEditProductESD";
import Button from "@/components/elements/Button.vue";
import Slideover from "@/components/layout/Slideover.vue";

const OrderApi = ApiFactory.get("orders");

export default {
  name: "OrderEditESD",
  components: {
    Button,
    Slideover,
    OrderEditProductESD
  },
  props: {
    title: {
      type: String,
      default: "Title"
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      processing: false,
      error: false,
      updatedProducts: [],
    };
  },
  computed: {
    order() {
      return this.$store.getters["orders/get"]("order");
    },
    editable() {
      if (!this.order.details) {
        return [];
      }
      return this.order.details.filter(detail => {
        if (String(detail.Adjustment) !== "0") {
          return false;
        }

        if (String(detail.Canceled) !== "0") {
          return false;
        }

        if (detail.Type == null || detail.Type === "K") {
          return true;
        }

        return false;
      });
    },
    canUpdate() {
      return (! this.processing);
    },
  },
  methods: {
    updateESD(event) {
      // remove an old entry, if exists
      this.updatedProducts = this.updatedProducts.filter(product => product.ItemNumber !== event.ItemNumber);

      if (event.newExpectedShipDate == null) {
        return false;
      }

      this.updatedProducts.push(event);
    },
    update() {
      this.processing = true;
      this.error = false;

      OrderApi.editOrderProductsESD(this.order.SourceOrderNumber, {
        updated_products: this.updatedProducts
      }).then(() => {
        this.$emit('toggle-slideover');
        this.$emit('refresh-order');
      }).catch(() => {
        this.error = true
      }).finally(() => {
        this.processing = false
      });
    }
  }
};
</script>
